import useOnAnnotationCreateRubberStampToolMode from './useOnAnnotationCreateRubberStampToolMode';

export default useOnAnnotationCreateRubberStampToolMode;